import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "./html.scss";

const Html = () => {
  const [projects, setProjects] = useState([]);
  const [header, setHeader] = useState("");
  const [activeProject, setActiveProject] = useState("html");

  const fetchProjects = async (project_title) => {
    try {
      const response = await fetch(`/${project_title}.json`); // Assuming `html.json` is in the public folder
      const data = await response.json();
      console.log("data", data);
      setHeader(data.project_header); // Set the header
      setProjects(data.data); // Set the project data
      setActiveProject(project_title); // Set the active project
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects("html"); // Fetch default projects on initial render
  }, []);

  return (
    <>
      <section id="works" className="work py-5">
        <Container className="py-md-5">
          <div className="text-center">
            <h5 className="title-small text-uppercase">Other Projects</h5>
            <h3 className="fs-1 fw-bold">
              List of projects I have been doing in the last one year
            </h3>
          </div>
          <Row className="py-5">
            <div className="d-flex flex-wrap gap-2 mb-5 justify-content-start">
              <Button
                onClick={() => fetchProjects("html")}
                className={`project-btn ${activeProject === "html" ? "active-btn" : ""}`}
              >
                HTML - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("bootstrap")}
                className={`project-btn ${activeProject === "bootstrap" ? "active-btn" : ""}`}
              >
                BOOTSTRAP - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("jsdom")}
                className={`project-btn ${activeProject === "jsdom" ? "active-btn" : ""}`}
              >
                JavaScript-DOM - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("es6")}
                className={`project-btn ${activeProject === "es6" ? "active-btn" : ""}`}
              >
                ES6 - API - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("reactjs")}
                className={`project-btn ${activeProject === "reactjs" ? "active-btn" : ""}`}
              >
                REACT JS - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("react-router")}
                className={`project-btn ${activeProject === "react-router" ? "active-btn" : ""}`}
              >
                REACT ROUTER - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("react_firebase_auth")}
                className={`project-btn ${activeProject === "react_firebase_auth" ? "active-btn" : ""}`}
              >
                REACT FIREBASE AUTH - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("mern")}
                className={`project-btn ${activeProject === "mern" ? "active-btn" : ""}`}
              >
                MERN STACK - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("redux")}
                className={`project-btn ${activeProject === "redux" ? "active-btn" : ""}`}
              >
                REACT REDUX - Projects
              </Button>
            </div>

            <h2>{header ? header : ""}</h2>
            <br />
            <br />
            <br />
            {/* API call start */}
            {projects.map((project, index) => (
              <Col className="mb-4" xs={12} md={6} lg={4} key={index}>
                <Card style={{ height: "372px" }}>
                  <Card.Img variant="top" src={project.img_url} />
                  <Card.Body>
                    <Card.Title className="fs-4">{project.title}</Card.Title>
                    <Card.Text>{project.description}</Card.Text>
                    <div className="d-flex justify-content-between">
                      <a
                        target="_blank"
                        rel="noreferrer noopener"
                        className="card__btn"
                        href={project.live_url}
                      >
                        Live
                      </a>
                      {project.code_link && (
                        <a
                          target="_blank"
                          rel="noreferrer noopener"
                          className="card__btn"
                          href={project.code_link}
                        >
                          Code Link
                        </a>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Html;
